"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveSubTasksPlugin = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const workflow_core_1 = require("@sierralabs/workflow-core");
const CreateSubTasksPlugin_1 = require("./CreateSubTasksPlugin");
const StyledConfiguratorDiv = styled_components_1.default.div `
  .field {
    margin-top: 12px;
    margin-bottom: 12px;
  }
`;
const RemoveSubTasksConfigurator = props => {
    var _a;
    const { stateNode, onChange } = props;
    const [invoke, setInvoke] = (0, react_1.useState)(props.invoke);
    if (!invoke.data)
        invoke.data = {};
    const data = invoke.data;
    const states = ((_a = stateNode.parent) === null || _a === void 0 ? void 0 : _a.states) || [];
    const selectedStates = states.filter(state => {
        var _a;
        return (_a = data.statePaths) === null || _a === void 0 ? void 0 : _a.some(statePath => {
            return (0, workflow_core_1.compareTaskStatus)(statePath, state.path);
        });
    });
    const update = (data) => {
        const updatedInvoke = Object.assign(Object.assign({}, invoke), { data });
        setInvoke(updatedInvoke);
        onChange === null || onChange === void 0 ? void 0 : onChange(updatedInvoke);
    };
    return (react_1.default.createElement(StyledConfiguratorDiv, null,
        react_1.default.createElement(lab_1.Autocomplete, { multiple: true, fullWidth: true, className: 'field', options: states, value: selectedStates, getOptionLabel: option => option.name, 
            // use filterOptions instead of filtering the options
            // to allow invalid values in selectedStates
            // e.g. CreateSubTasks plugin was removed from a state
            filterOptions: states => {
                // only get states that have CreateSubTasks actions
                return states.filter(state => {
                    const invokes = Array.isArray(state.invoke)
                        ? state.invoke
                        : state.invoke
                            ? [state.invoke]
                            : [];
                    return invokes.some((invoke) => {
                        return invoke.src === CreateSubTasksPlugin_1.CreateSubTasksPlugin.src;
                    });
                });
            }, getOptionSelected: (option, value) => {
                return (0, workflow_core_1.compareTaskStatus)(option.path, value.path);
            }, onChange: (_, states) => {
                update({ statePaths: states.map(state => state.path) });
            }, renderInput: params => (react_1.default.createElement(core_1.TextField, Object.assign({}, params, { fullWidth: true, size: 'small', variant: 'outlined', label: 'Workflow States', placeholder: 'Remove Sub Tasks from selected states', helperText: react_1.default.createElement(react_1.default.Fragment, null,
                    "Only the Workflow states with a configured",
                    ' ',
                    react_1.default.createElement("strong", null, CreateSubTasksPlugin_1.CreateSubTasksPlugin.name),
                    " action can be selected.") }))) }),
        react_1.default.createElement(lab_1.Alert, { severity: 'info' },
            react_1.default.createElement("div", null, (data.statePaths || []).length > 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
                "This action will remove only the assigned sub tasks created from the selected ",
                react_1.default.createElement("strong", null, "workflow states"),
                " when entering into this workflow state.")) : ('This action will remove any assigned sub tasks when entering into this workflow state.')))));
};
const RemoveSubTasksDisplay = props => {
    const { invoke } = props;
    const data = invoke.data;
    const statePaths = (data === null || data === void 0 ? void 0 : data.statePaths) || [];
    return statePaths.length === 0 ? null : (react_1.default.createElement("div", null,
        "for:",
        ' ',
        statePaths.map((statePath, index, array) => (react_1.default.createElement(react_1.Fragment, { key: `${statePath}-${index}` },
            react_1.default.createElement("strong", null, (0, workflow_core_1.parseTaskStatus)(statePath)),
            index < array.length - 1 && ', ')))));
};
exports.RemoveSubTasksPlugin = {
    src: 'removeSubTasks',
    name: 'Remove Sub Tasks',
    configurator: RemoveSubTasksConfigurator,
    display: RemoveSubTasksDisplay,
    validate: () => true,
    service: (state, params) => {
        console.log('removeSubTasks params', state, params);
        return true;
    }
};
//# sourceMappingURL=RemoveSubTasksPlugin.js.map